module.exports = __webpack_public_path__ + "static/media/caret-down.9cbcc982.svg";